import { render, staticRenderFns } from "./ViewServerMigration.vue?vue&type=template&id=44f4c1f2&"
import script from "./ViewServerMigration.vue?vue&type=script&lang=ts&"
export * from "./ViewServerMigration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports